import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M8.1.8c2.03 0 3.94.8 5.37 2.23A7.55 7.55 0 0115.7 8.4c0 2.03-.79 3.94-2.23 5.37A7.55 7.55 0 018.1 16a7.55 7.55 0 01-5.37-2.23A7.55 7.55 0 01.5 8.4c0-2.03.79-3.94 2.23-5.37A7.55 7.55 0 018.1.8zM1.3 8.4a6.8 6.8 0 1013.61-.01A6.8 6.8 0 001.3 8.4z",
      "clip-rule": "evenodd"
    }),
    _createElementVNode("path", { d: "M8.24 3.67c.16 0 .3.06.42.17a.56.56 0 01.17.42.57.57 0 01-.17.42.56.56 0 01-.42.18.57.57 0 01-.42-.18.57.57 0 01-.18-.42c0-.16.06-.3.17-.42a.58.58 0 01.43-.17zm.49 2.8v4.32c0 .33.02.56.07.67a.53.53 0 00.21.25c.1.05.28.08.53.08V12h-2.6v-.21c.25 0 .43-.03.52-.08a.5.5 0 00.21-.25c.06-.12.08-.34.08-.67V8.72c0-.58-.01-.96-.05-1.13-.03-.13-.07-.21-.13-.26a.35.35 0 00-.24-.07c-.1 0-.24.03-.4.08l-.08-.2 1.62-.66h.26z" })
  ]))
}
